import React, { useState, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Sidebar from '../components/sidebar';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import { Card, CardHeader, CardMedia, CardContent, Typography } from '@material-ui/core';
import { useSpring, animated } from 'react-spring'; // web.cjs is required for IE 11 support
import PropTypes from 'prop-types';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import TextField from '@material-ui/core/TextField';


import * as firebase from 'firebase';
import { sendFund } from '../utils/firebase';

const useStyles = makeStyles(theme => ({
    root: {
        maxWidth: 345,
        flexGrow: 1,
    },
    media: {
        height: 140,
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
}));

const Fade = React.forwardRef(function Fade(props, ref) {
    const { in: open, children, onEnter, onExited, ...other } = props;
    const style = useSpring({
        from: { opacity: 0 },
        to: { opacity: open ? 1 : 0 },
        onStart: () => {
            if (open && onEnter) {
                onEnter();
            }
        },
        onRest: () => {
            if (!open && onExited) {
                onExited();
            }
        },
    });

    return (
        <animated.div ref={ref} style={style} {...other}>
            {children}
        </animated.div>
    );
});

Fade.propTypes = {
    children: PropTypes.element,
    in: PropTypes.bool.isRequired,
    onEnter: PropTypes.func,
    onExited: PropTypes.func,
};



function Listing(props) {
    const [amount, setAmount] = useState('');

    const classes = useStyles();
    const [open, setOpen] = React.useState(false);

    const handleOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };
    const sendFunds = (amount) => {
        //do funds
        console.log("HAHAHAH")
        sendFund(firebase.auth().currentUser.uid, props.id, amount)
        setOpen(false);
    }





    return (
        <div>
            <Card className={classes.root}>
                <CardActionArea>
                    <CardMedia className={classes.media}>
                        <img src="https://images.unsplash.com/photo-1559251606-c623743a6d76?ixlib=rb-1.2.1&dpr=2&auto=format&fit=crop&w=416&h=312&q=60" />
                    </CardMedia>
                    <CardContent>
                        <Typography gutterBottom variant="h5" component="h2">
                            {props.name}
                        </Typography>
                        <Typography variant="body2" color="textSecondary" component="p">
                            {formatString(props.description)}
                        </Typography>
                    </CardContent>
                </CardActionArea>
                <CardActions>
                    <Button size="small" color="primary" variant="contained"
                        onClick={handleOpen}>
                        Fund now
        </Button>
                    <Button size="small" color="primary" variant="outlined">
                        Learn More
        </Button>
                </CardActions>
            </Card>

            <Modal
                aria-labelledby="spring-modal-title"
                aria-describedby="spring-modal-description"
                className={classes.modal}
                open={open}
                onClose={handleClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={open}>
                    <div className={classes.paper}>
                        <h2 id="spring-modal-title">{props.name}</h2>
                        <p id="spring-modal-description"> {props.description}</p>
                        <p id="spring-modal-description">Funding Goal: {props.amount} </p>

                        <form className={classes.form} noValidate >
                            <TextField
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                id="amount"
                                label="Donate amount"
                                name="amount"
                                autoComplete="amount"
                                autoFocus
                                value={amount}
                                onChange={(e) => setAmount(e.target.value)}
                            />

                        <Button type="submit" onClick={() => sendFunds(amount)}>
                            Send funds!
                        </Button>
                        </form>
                    </div>
                </Fade>
            </Modal>

        </div>
    );
}




function formatString(str) {
    return str.substring(0, 40) + "..."
}



export default function Home(props) {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    const [listings, setListings] = React.useState(null);
    useEffect(() => {
        if(!listings) {
            load
        }
      }, []);

    const [item, setItem] = useState(null);
    const load = firebase.database().ref('listings').once('value')
        .then(result => {
            console.log("result:", result.val());
            let res = result.val();
             setListings(
                <div>
                    <Grid container spacing={1}>
                        {
                            Object.keys(res).map(function (key, index) {
                                return (
                                    <Grid item xs={6}>
                                        <Listing id={key} name={res[key].companyName} description={res[key].description} amount={res[key].fundingGoal} />
                                    </Grid>
                                )
                            })
                        }
                    </Grid>
                </div>
            )
        }
        )
        return listings;
}




// WEBPACK FOOTER //
// ./src/components/home.js